
const ELEMENT_INFO = {
  dateTime: {
    label: "Date time",
    elements: [
      "datetime",
      "datetimeEpoch",
      "tzoffset"
    ]
  },

  temperature: {
    label: "Temperature",
    elements: [
      "tempmax",
      "tempmin",
      "temp",
      //"tempBase",
      "tempwet",
      "feelslikemax",
      "feelslikemin",
      "feelslike",
      "dew",
      "deltat"
      //{ id: "wbgt", premium: true, beta: true},
    ]
  },

  humidityClouds: {
    label: "Humidity & Clouds",
    elements: [
      "humidity",
      "cloudcover",
      "visibility"
    ]
  },

  precipitation: {
    label: "Precipitation",
    elements: [
      "precip",
      "precipprob",
      "precipcover",
      "preciptype",
      //"frozenprecippercent",
      "snow",
      "snowdepth",
      "precipremote",
      "preciprate",
      "reflectivity"
    ]
  },

  windPressure: {
    label: "Wind & Pressure",
    elements: [
      "windspeed",
      "windspeedmax",
      "windspeedmin",
      "windspeedmean",
      "windgust",
      "winddir",
      "pressure",
      // higher-alt wind (examples that may need flags)
      { id: "windspeed50", premium: true },
      { id: "winddir50", premium: true },
      { id: "windspeed80", premium: true },
      { id: "winddir80", premium: true },
      { id: "windspeed100", premium: true },
      { id: "winddir100", premium: true }
    ]
  },

  solar: {
    label: "Solar",
    elements: [
      "solarradiation",
      "solarenergy",
      "uvindex",
      "uvindex2",
     // { id: "clearsolar", premium: true }
    ]
  },

  astronomy: {
    label: "Astronomy",
    elements: [
      "sunrise",
      "sunset",
      "moonphase",
      "moonrise",
      "moonset",
      { id: "sunazimuth" },
      { id: "sunelevation" },
      //{ id: "sundeclination" }
    ]
  },

  conditions: {
    label: "Conditions",
    elements: [
      "conditions",
      //"description",
      "icon",
      //"weathertype",
    
    ]
  },

  airQuality: {
    label: "Air Quality",
    elements: [
      "aqius",
      "aqieur",
      "aqielement",
      "pm1",
      "pm2p5",
      "pm10",
      "so2",
      "no2",
      "o3",
      "co",
      "smokesfc",
      "smokecol",
      "dust",
      "aod550",
      "hainesindex"
    ]
  },

  soil: {
    label: "Soil & Moisture",
    elements: [
      { id:"soiltemp01", premium: true },
      { id:"soiltemp04", premium: true },
      { id:"soiltemp10", premium: true },
      { id:"soiltemp20", premium: true },
      { id:"soilmoisture01", premium: true },
      { id:"soilmoisture04", premium: true },
      { id:"soilmoisture10", premium: true },
      { id:"soilmoisture20", premium: true },
      { id: "soilmoisturevol01", premium: true },
      { id: "soilmoisturevol04", premium: true },
      { id: "soilmoisturevol10", premium: true },
      { id: "soilmoisturevol20", premium: true },
      { id: "et0", premium: true }
    ]
  },

  radiationAdvanced: {
    label: "Radiation (advanced)",
    elements: [
      { id: "ghiradiation", premium: true },
      { id: "dniradiation", premium: true },
      { id: "difradiation", premium: true },
      { id: "gtiradiation", premium: true },
      /*
      { id: "ghiradiationclear", premium: true },
      { id: "dniradiationclear", premium: true },
      { id: "dhiradiationclear", premium: true },
      { id: "ghiradiationcalc", premium: true },
      { id: "dniradiationcalc", premium: true },
      { id: "dhiradiationcalc", premium: true }
       */
    ]
  },
  severe: {
    label: "Severe Weather",
    elements: [
      "cape",
      "cin",
      "severerisk",
      "hailsize",
      "lightningdensity",
      "hailprobability",
      "severehailindex"
    ]
  },
  degreeDays: {
    label: "Degree Days",
    elements: [
      { id: "degreedays", premium: true },
      { id: "accdegreedays", premium: true }
    ]
  },

  marine: {
    label: "Marine & Waves",
    elements: [
      { id: "wavedir", premium: true },
      { id: "waveheight", premium: true },
      { id: "waveperiod", premium: true },
      { id: "maxwaveheight", premium: true },
      { id: "swellheight", premium: true },
      { id: "swellperiod", premium: true },
      { id: "swelldir", premium: true }
    ]
  },
  locationInfo:{
    elements: [
      { id: "name" },
      { id: "address" },
      { id: "resolvedAddress" },
      { id: "latitude" },
      { id: "longitude" },
      { id: "elevation" },
      { id: "timezone" },
      { id: "tzoffset" }
    ]
  },
  info: {
    label: "Info",
    elements: [
      "stations",
      "source",
      "description"
      /*
      
      "feedid",
      "geocodes",
      "geometries",
      "event",
      "events",
      "onset",
      "ends"*/
    ]
  }
};
export default ELEMENT_INFO;



import { ELEMENT_META, resolveUnit } from './elementInfoMeta.js';

// when enriching:
function enrichElement(base, unitGroup = 'metric') {
  const meta = ELEMENT_META[base.id] || {};
  return {
    ...base,
    label: base.label ?? meta.label ?? humanizeId(base.id),
    description: base.description ?? meta.description ?? '',
    unit: base.unit ?? resolveUnit(meta.unit, unitGroup),
    precision: base.precision ?? meta.precision ?? null,
    aggregation: base.aggregation ?? meta.aggregation,
    premium: typeof base.premium === 'boolean' ? base.premium : !!meta.premium
  };
}

// --- small helpers ---
function humanizeId(id) {
  return id
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, s => s.toUpperCase());
}


// replace internal usage where elements are produced to the UI:
export function getAllGroupsEnriched(unitGroup = 'metric') {
  const out = {};
  for (const [key, group] of Object.entries(ELEMENT_INFO)) {
    out[key] = {
      ...group,
      elements: normalizeelements(group.elements).map(el => enrichElement(el, unitGroup))
    };
  }
  return out;
}

/**
 * Normalize a element entry into an object of shape:
 * { id: string, premium?: boolean, ...customProps }
 */
export function normalizeElement(element) {
  return typeof element === "string" ? { id: element } : element;
}

/**
 * Normalize an array of mixed elements.
 */
export function normalizeelements(elements) {
  return elements.map(normalizeElement);
}

/**
 * Get a group by id (camelCase key).
 */
export function getGroup(groupId) {
  return ELEMENT_INFO[groupId] || null;
}

/**
 * Return normalized elements for a group id or group object.
 */
export function getelements(groupOrId) {
  const group = typeof groupOrId === "string" ? getGroup(groupOrId) : groupOrId;
  if (!group) return [];
  return normalizeelements(group.elements || []);
}

/**
 * Iterate elements as normalized objects.
 */
export function forEachelement(groupOrId, fn) {
  getelements(groupOrId).forEach(fn);
}

/**
 * Create a map { [elementId]: ElementObject } for quick lookup.
 */
export function createElementMap(groupOrId) {
  const map = Object.create(null);
  forEachElement(groupOrId, element => { map[element.id] = element; });
  return map;
}

/**
 * Find a specific element object by id within a group.
 */
export function getElement(groupOrId, elementId) {
  return getelements(groupOrId).find(c => c.id === elementId) || null;
}

/**
 * Flatten all groups to a single normalized element list (optionally unique by id).
 */
export function getAllelements({ dedupe = true } = {}) {
  const seen = new Set();
  const out = [];
  for (const key of Object.keys(ELEMENT_INFO)) {
    for (const element of getelements(key)) {
      if (!dedupe || !seen.has(element.id)) {
        out.push(element);
        seen.add(element.id);
      }
    }
  }
  return out;
}

/**
 * Return a full object of all groups, but with elements normalized.
 * Keeps the group structure intact.
 */
export function getAllGroups() {
  const out = {};
  for (const [key, group] of Object.entries(ELEMENT_INFO)) {
    out[key] = {
      ...group,
      elements: normalizeelements(group.elements)
    };
  }
  return out;
}
